// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"296":"component---src-pages-404-tsx","348":"component---src-pages-index-tsx"}[chunkId] + "-" + {"296":"f22bc4b2a0ff05a8708b","348":"50cb1e02e93d6de27544"}[chunkId] + ".js";
};